// Bun inlines BUN_PUBLIC_* only when the var is set; see api.ts.
function publicUrl(): string | undefined {
  try {
    return process.env.BUN_PUBLIC_ADMIN_URL
  } catch {
    return undefined
  }
}

export const ADMIN_URL = publicUrl() || 'http://localhost:3001'
